import gsap from '../../../gsap-public/esm/index.js';

class ContactForm {
  constructor() {
    this.form = document.querySelector('[data-contact-form]');
    if (!this.form) return;

    this.bind();
  }

  bind() {
    this.form.addEventListener('submit', (e) => this.handleSubmit(e));

    // Add focus animations to inputs
    const inputs = this.form.querySelectorAll('input, textarea');
    inputs.forEach(input => {
      input.addEventListener('focus', (e) => this.animateInputFocus(e.target));
      input.addEventListener('blur', (e) => this.animateInputBlur(e.target));
    });
  }

  animateInputFocus(input) {
    const label = input.previousElementSibling;
    if (!label) return;

    gsap.to(label, {
      y: -8,
      scale: 0.85,
      color: 'var(--color-accent)',
      duration: 0.3,
      ease: 'power2.out'
    });
  }

  animateInputBlur(input) {
    if (input.value) return; // Keep label up if value exists

    const label = input.previousElementSibling;
    if (!label) return;

    gsap.to(label, {
      y: 0,
      scale: 1,
      color: 'var(--color-text)',
      duration: 0.3,
      ease: 'power2.out'
    });
  }

  async handleSubmit(e) {
    e.preventDefault();

    const button = this.form.querySelector('button[type="submit"]');
    const formData = new FormData(this.form);

    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Sending...';

    try {
      const response = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData).toString()
      });

      if (!response.ok) throw new Error('Form submission failed');

      this.showSuccess();
      this.form.reset();
    } catch (error) {
      this.showError('Something went wrong. Please try again.');
    } finally {
      button.disabled = false;
      button.textContent = originalText;
    }
  }

  showSuccess() {
    // Create success message
    const message = document.createElement('div');
    message.className = 'form-message form-message--success';
    message.textContent = 'Thanks! We\'ll be in touch soon.';

    this.form.appendChild(message);

    gsap.from(message, {
      opacity: 0,
      y: 20,
      duration: 0.5,
      ease: 'power2.out'
    });

    // Remove message after delay
    setTimeout(() => {
      gsap.to(message, {
        opacity: 0,
        onComplete: () => message.remove()
      });
    }, 5000);
  }

  showError(text) {
    const message = document.createElement('div');
    message.className = 'form-message form-message--error';
    message.textContent = text;

    this.form.appendChild(message);

    gsap.from(message, {
      opacity: 0,
      x: -20,
      duration: 0.3,
      ease: 'power2.out'
    });

    setTimeout(() => {
      gsap.to(message, {
        opacity: 0,
        onComplete: () => message.remove()
      });
    }, 5000);
  }
}

export default ContactForm;
